
const baseURL = {
    local: 'http://localhost:3082',
    prod: '://api-cdn.ecal.com/apiv3/',  
    stage: '://staging-api-cdn.ecal.com/apiv3/',  
    test: '://api-cdn.ecal.com/apiv3/',
};

export default baseURL;
